/* eslint-disable react-hooks/exhaustive-deps */
import React, { createRef, useRef, useEffect, useMemo, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Checkbox } from '@mui/material';
import clsx from "clsx";
import customSortIcon from "../Icons/sortIcon";
import sortIconUp from "../Icons/sortIconUp";
import customStyles from "../../../../assets/styles/customStyles";
import { Waypoint } from 'react-waypoint';
import resizeIcon from "../../../../assets/images/icon_actions/resizeIcon.svg"
import { getColumnWidth } from "../../../../helpers/utilities";

const DEFAULT_MIN_WIDTH_CELL = 50;
const DEFAULT_MAX_WIDTH_CELL = 1800;

export default function CustomInfiniteScroll(props) {
    const isResizing = useRef(-1);

    const { heads, component, sortOrder, id, sortBy, onRequestSort, loadMoreTask, keyValue = 'id',
        customClasses, loadMoreContent, onCheckCheckBox, onSelected, details = [], selected = [], styles, autoWidth } = props;

    const columnRefs = useMemo(() => heads && heads?.map(i => createRef()), []);
    const [active, setActive] = useState('');
    const classes = customStyles();

    useEffect(() => {
        // loadColumnInfoLocalStorage();
        document.onmousemove = handleOnMouseMove;
        document.onmouseup = handleOnMouseUp;

        return () => {
            document.onmousemove = null;
            document.onmouseup = null;
            localStorage.setItem("columnsInfo", null);
        };
    }, []);


    const adjustWidthColumn = (index, width) => {
        const minWidth = heads[index]?.minWidth ?? DEFAULT_MIN_WIDTH_CELL;
        const maxWidth = columnRefs[index]?.maxWidth ?? DEFAULT_MAX_WIDTH_CELL;
        let newWidth = "auto";
        if (width !== 'auto') {
            newWidth = width > maxWidth ? maxWidth + 'px' : width < minWidth ? minWidth + 'px' : width + 'px';
        }
        setActive(index);

        if (columnRefs[index].current?.parentElement) {
            columnRefs[index].current.parentElement.style.width = newWidth;
            if (columnRefs[index].current.parentElement.getElementsByTagName("span").length > 0) {
                columnRefs[index].current.parentElement.getElementsByTagName("span")[0].style.width = newWidth;
            }
            var tableRow = document.getElementsByTagName('tr');
            for (var t = 0; t < tableRow.length; t++) {
                if (tableRow[t].getElementsByTagName("td")[index]) {
                    tableRow[t].getElementsByTagName("td")[index].style.width = newWidth;
                    if (tableRow[t].getElementsByTagName("td")[index]?.getElementsByTagName("span").length > 0) {
                        tableRow[t].getElementsByTagName("td")[index].getElementsByTagName("span")[0].style.width = newWidth;
                    }
                    if (tableRow[t].getElementsByTagName("td")[index]?.getElementsByTagName("a").length > 0) {
                        tableRow[t].getElementsByTagName("td")[index].getElementsByTagName("a")[0].style.width = newWidth;
                    }
                }
            }
        }
    };

    const saveColumnInfoLocalStorage = () => {
        let columnsInfo = {};
        heads && heads?.forEach((col, index) => {
            columnsInfo[col.name] = {};
            columnsInfo[col.name] = columnRefs[index]?.current?.parentElement.style.width;
        });
        localStorage.setItem("columnsInfo", JSON.stringify(columnsInfo));
    };

    const setCursorDocument = (isResizing, index) => {
        document.body.style.cursor = isResizing ? `url(${resizeIcon}, pointer` : "auto";
        if (isResizing) {
            document.body.classList.add(classes.tableResize);
            handleMouseEnter(index);
        } else {
            document.body.classList.remove(classes.tableResize);
            handleMouseLeave(index);
        }
    };

    const handleOnMouseUp = () => {
        if (isResizing.current >= 0) {
            setCursorDocument(false, isResizing.current);
            isResizing.current = -1;
            setActive(-1);
            saveColumnInfoLocalStorage();
        }
    };

    const handleOnMouseMove = (e) => {
        if (columnRefs) {
            if (isResizing.current >= 0) {
                const newWidth =
                    e.clientX -
                    columnRefs[
                        isResizing.current
                    ].current?.parentElement?.getBoundingClientRect().left;
                adjustWidthColumn(isResizing.current, newWidth);
            }
        }
    };

    const onClickResizeColumn = (index) => {
        isResizing.current = index;
        setCursorDocument(true, index);
    };

    const onSelectAllClick = (e) => {
        if (e.target.checked) {
            const newSelecteds = details && details.map((n) => n[keyValue]);
            if (onSelected) {
                onSelected(newSelecteds);
            }
            if (onCheckCheckBox) {
                onCheckCheckBox(e.target);
            }
            return;
        }
        if (onSelected) {
            onSelected([]);
        }

        if (onCheckCheckBox) {
            onCheckCheckBox(e.target);
        }

    };

    const handleMouseLeave = (i) => {
        let tableRow = '';
        if (id) {
            tableRow = document.querySelectorAll('#' + id + ' tr');
        } else {
            tableRow = document.getElementsByTagName('tr')
        }

        for (var t = 0; t < tableRow.length; t++) {
            if (tableRow[t].getElementsByTagName("td")[i]) {
                tableRow[t].getElementsByTagName("td")[i].classList.remove(classes.tableColHoverColor);
            }
            if (tableRow[t].getElementsByTagName("th")[i]) {
                tableRow[t].getElementsByTagName("th")[i].classList.remove(classes.tableColHoverColor);
            }
        }
    }

    const handleMouseEnter = (i) => {
        let tableRow = '';
        if (id) {
            tableRow = document.querySelectorAll('#' + id + ' tr');
        } else {
            tableRow = document.getElementsByTagName('tr')
        }

        //var tableRow = document.getElementsByTagName('tr');
        for (var t = 0; t < tableRow.length; t++) {
            if (tableRow[t].getElementsByTagName("td")[i]) {
                tableRow[t].getElementsByTagName("td")[i].classList.add(classes.tableColHoverColor);
            }
            if (tableRow[t].getElementsByTagName("th")[i]) {
                tableRow[t].getElementsByTagName("th")[i].classList.add(classes.tableColHoverColor);
            }
        }
    }

    const handleDoubleClick = (i) => {
        adjustWidthColumn(i, (1600 / heads.length));
        saveColumnInfoLocalStorage();
        setActive(-1);
    }

    return (
        <TableContainer className={clsx(customClasses, classes.tablecontain)} style={{ styles }}>
            <Table id={id} stickyHeader>
                <TableHead>
                    <TableRow>{heads && heads?.map((head, i) => (
                        <TableCell style={{ width: autoWidth ? 'auto' : getColumnWidth(heads, i) }}
                            onMouseEnter={() => isResizing.current === -1 ? handleMouseEnter(i) : ''}
                            onMouseLeave={() => isResizing.current === -1 ? handleMouseLeave(i) : ''}
                            title={head.helpText}
                            key={i}
                            className={clsx(head.key, classes.tablealign,
                                { [classes.headActive]: active === i },
                                { [classes.sortColParent]: head.sorting },
                                { [classes.amountRightAlign]: head.amount },
                                { [classes.textAlignRight]: head.rightAlign },
                                { [classes.textAlignLeft]: head.leftAlign },
                                { [classes.textAlignCenter]: head.centerAlign })}>
                            {
                                head.sorting ? <TableSortLabel
                                    style={{ width: autoWidth ? 'auto' : getColumnWidth(heads, i) }}
                                    className={classes.sortCol}
                                    IconComponent={sortOrder === 'asc' && sortBy === head.key ? sortIconUp : customSortIcon}
                                    direction={sortOrder}
                                    onClick={() => onRequestSort(head.key, sortOrder === 'asc' ? 'desc' : 'asc')}
                                >{head.name}</TableSortLabel> : head.key === 'checkbox' ?
                                    <Checkbox
                                        color="primary"
                                        indeterminate={selected.length > 0 && selected.length < details.length}
                                        checked={details.length > 0 && selected.length === details.length}
                                        onChange={(e) => onSelectAllClick(e)}
                                        inputProps={{ 'aria-label': 'select all desserts' }}
                                    /> : head.actionWidth ? <span style={{ width: head.actionWidth, display: "inline-block" }}
                                        className={classes.actionColumn}>{head.name}</span> :
                                        (head.key === 'action' || head.key === 'actions') ? <span>{head.name}</span> : <span style={{ width: autoWidth ? 'auto' : getColumnWidth(heads, i) }}>{head.name}</span>
                            }
                            {
                                head.name !== 'Actions' && <div
                                    onMouseDown={() => onClickResizeColumn(i)}
                                    onDoubleClick={(e) => handleDoubleClick(i)}
                                    ref={columnRefs[i]}
                                    className={classes.resizeLine}></div>
                            }
                        </TableCell>)
                    )}</TableRow>
                </TableHead>
                <TableBody>
                    {component}
                    {
                        loadMoreContent && <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
                            setTimeout(function () {
                                loadMoreTask(previousPosition);
                            }, 500);
                        }}>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={heads.length}>
                                    <div className={classes.loadMoreCircle}></div>
                                </TableCell>
                            </TableRow>
                        </Waypoint>
                    }
                </TableBody>
                {/* {
                    overflow &&
                    <>
                        <div className={clsx(classes.tableScrollIcon, classes.tableScrollIconLeft)}>
                            <Image
                                onClick={() => onScroll(-40)}
                                src={ScrollRight}
                                preview={false}
                            />
                        </div><div className={clsx(classes.tableScrollIcon, classes.tableScrollIconRight)}>
                            <Image
                                src={ScrollRight}
                                onClick={() => onScroll(40)}
                                preview={false}
                            />
                        </div>

                    </>
                } */}
            </Table>
        </TableContainer >
    );
}
